import { defineMessages } from "react-intl";

const messages = defineMessages({
  removeInvalidResourcesAlertSuffix: {
    id: "email.templateView.removeInvalidResourcesAlertSuffix",
    defaultMessage: "They will not be included when composing your email.",
    description: "Template view - Remove invalid resources alert suffix",
  },
  removeInvalidResourcesDisabledTooltip: {
    id: "email.templateView.removeInvalidResourcesDisabledTooltip",
    defaultMessage: "Only the template owner can edit this template.",
    description: "Template view - Remove invalid resources disabled tooltip",
  },
  resourcesRemoved: {
    id: "email.templateView.resourcesRemoved",
    defaultMessage: "Resource(s) removed",
    description: "Template view - Resources removed",
  },
  sectionBody: {
    id: "email.templateView.section.body",
    defaultMessage: "Body:",
    description: "Template preview section label for body",
  },
  sectionSubject: {
    id: "email.templateView.section.subject",
    defaultMessage: "Subject:",
    description: "Template preview section label for subject",
  },
});

export default messages;
